const screencheck = function(mediasize){
    return window.matchMedia("(max-width:"+ mediasize+"px)").matches;
};



let hovermenutimeout;
$("header .header-mauds__nav__item > a").hover(function() {
    if (!screencheck(1190)) {
        $("header .header-mauds__nav__item.hover").removeClass('hover');
        $(this).parents(".header-mauds__nav__item").addClass("hover");
        clearTimeout(hovermenutimeout);
    }
}, function() {
   if (!screencheck(1190)) {
        hovermenutimeout = setTimeout(() => {
            $(this).parents(".header-mauds__nav__item").removeClass("hover");
        },200)
    }
});

$("header .header-mauds__nav__submenu__container").on("mouseenter",function() {
   if (!screencheck(1190)) {
      clearTimeout(hovermenutimeout);
  }
});

$("header .header-mauds__nav__submenu__container").on("mouseleave",function() {
    $("header .header-mauds__nav__item.hover").removeClass('hover');
});

if(!screencheck(1189)){
  let submenuTabTimeout;

  $("header .tab-lists .tab-item").on("mouseenter",function(){
    clearTimeout(submenuTabTimeout);
    let tabId = $(this).attr("tab-id");
    let tab = $(`#${tabId}`);
    let thisTab = $(this).closest(".navmenu-inner-content-wrapper")

    if(!tab.length) {
      return false;
    };

    submenuTabTimeout = setTimeout(() => {
      thisTab.find(".tab-item").removeClass("active");
      $(this).addClass("active");


      if(!screencheck(1190)){
        thisTab.find(".tab").not(tab).fadeOut(200,function(){
          thisTab.find(".tab").removeClass("active");
            tab.addClass("active").fadeIn(200,function(){
              tab.css("display","flex")
            });
        });
      }else{
          thisTab.find(".tab").removeClass("active");
          tab.addClass("active");
      }
    },20)

    return false;
  });

}else{
  $("header .tab-lists .tab-item > .icon").on("click",function(){
    let tab_item = $(this).parent(".tab-item");
    let tabId = tab_item.attr("tab-id");
    let tab = $(`#${tabId}`);

    if(!tab.length) {
      return false;
    };

    $("header .tab-lists .tab-item").removeClass("active");
    tab_item.addClass("active");

    $(".tab").removeClass("active");
    tab.addClass("active");

    return false;
  });
}


if(screencheck(1189)){

  $("header .tab-item.active").removeClass("active");
  $(".navmenu-inner-content-wrapper .tab.active").removeClass("active");

  $(".header-mauds__nav__item  .accrodion-button").on("click",function() {
    let parent = $(this).parents(".header-mauds__nav__item");

    $(".header-mauds__nav__item").not(parent).removeClass("open");
    $(".header-mauds__nav__submenu").not(parent.find(".header-mauds__nav__submenu")).slideUp(200);

    parent.toggleClass("open");
    parent.find(".header-mauds__nav__submenu").slideToggle(200);

    return false;
  });

  $(".accrodion-button").eq(0).click();

  $("header .tab .heading-row .back-button").on("click",function(){
    $("header .tab-item.active").removeClass("active");
    $(this).parents(".tab").removeClass("active");
    return false;
  });
   $("header .header-mauds__nav__item.Coffee").removeClass("open");
   $(".header-mauds__nav__submenu").slideUp(200);
};

$(document).on("click",".snize-ac-results-mobile .snize-close-button-arrow",function(){
  $(".snize-ac-results-mobile").hide();
})

$(document).ready(function () {
  let ajaxRequest = null;
  let hoverTimer = null;
  const productCache = {};

  function buildProductsHtml(products) {
    if (!products.length) {
      return '<p>No products found in this collection.</p>';
    }
    return products.map(product => {
      const prices = (product.variants || [])
        .map(v => parseFloat(v.price))
        .filter(p => !isNaN(p));
      const minPrice = prices.length ? Math.min(...prices).toFixed(2) : '';
      return `
              <div class="product">
                <a href="/products/${product.handle}" class="product-image">
                  <figure>
                    <img src="${product.images[0]?.src || ''}" width="54" height="54" alt="${product.title}" />
                  </figure>
                </a>
                <div class="product-details">
                  <div class="yotpo-custom-stars--container">
                    <div class="yotpo bottomLine" data-product-id="${product.id}">
                    </div>
                  </div>
                  <a href="/products/${product.handle}" class="product-name">${product.title}</a>
                  <a href="/products/${product.handle}" class="btn-outline">Quick Buy <span class="btn-price">- $${minPrice} </span></a>
                </div>
              </div>
            `;
    }).join('');
  }

  function renderProducts($container, products) {
    const html = buildProductsHtml(products);
    setTimeout(() => {
      $container.html(html);

      if (screencheck(1189) || !document.querySelector('.header-mega-menu-pwd')) {
        if ( typeof yotpo !== 'undefined' && yotpo ) {
          yotpo.refreshWidgets();
        }
      }

    }, 10);
  }

  function loadCollectionProducts({ handle, tabId, collectionUrl, onSuccess, onError }) {
    if (!handle || !tabId) return;

    if (collectionUrl) {
      $('.sidebar-collection-url').attr('href', collectionUrl);
    }

    const $container = $(`#${tabId} .productContainer`);
    if (!$container.length) return;

    let productLimit = $container.data('value') || 4;
    if (screencheck(1189)) {
      productLimit *= 2;
    }
    const cacheKey = `${handle}:${productLimit}`;

    if (productCache[cacheKey]) {
      renderProducts($container, productCache[cacheKey]);
      if (typeof onSuccess === 'function') onSuccess(productCache[cacheKey]);
      return;
    }

    if (ajaxRequest !== null) {
      ajaxRequest.abort();
    }

    ajaxRequest = $.ajax({
      url: `/collections/${handle}/products.json?limit=${productLimit}`,
      type: 'GET',
      dataType: 'json',
      beforeSend: function () {
        $container.html('<p>Loading...</p>');
      },
      success: function (response) {
        const products = response.products || [];
        productCache[cacheKey] = products;
        renderProducts($container, products);
        if (typeof onSuccess === 'function') onSuccess(products);
      },
      error: function (_jqXHR, textStatus) {
        if (textStatus === 'abort') return;
        $container.html('<p>Failed to load products.</p>');
        if (typeof onError === 'function') onError();
      },
      complete: function () {
        ajaxRequest = null;
      }
    });
  }

  $('.collection-class').on('mouseenter', function () {
    const this_collection_button = $(this);

    if (this_collection_button.hasClass("fetched")) {
      return false;
    }

    clearTimeout(hoverTimer);

    hoverTimer = setTimeout(() => {
      $('.collection-class').removeClass("fetched");
      this_collection_button.addClass("fetched");

      if (this_collection_button.parents(".tags-row").length) {
        $(".tags-row .tag").removeClass("active");
        this_collection_button.addClass("active");
      } else {
        $(".tags-row .tag.active").removeClass("active");
      }

      loadCollectionProducts({
        handle: this_collection_button.data('collection-handle'),
        tabId: this_collection_button.attr('tab-id'),
        collectionUrl: this_collection_button.data('collection-url')
      });
    }, 100);
  });
});



